<template>
    <div class="container-fluid bg bg-pj-jc m-0 p-0 font-italic animated fade-in slow" style="height: 100vh;">
        <div class="lime-bar-footer fixed-bottom"></div>
        <div class="container px-0">
            <div class="d-flex">
                <div class="mr-auto mt-3 ml-3">
                    <logo></logo>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-5 pt-5">
                <div class="d-flex mt-5 pt-5">
                    <div>
                        <div class="font-italic font-weight-bold text-uppercase font-xxl title">
                            please start your engines.
                        </div>
                        <div class="lime-bar-diag">
                            <img src="../assets/img/Asset_3.png" alt="">
                        </div>
                        <div class="px-5 font-sm text sub-title">we will contact you... maybe.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import logo from '@/components/RufusLogo'
    import firebase from 'firebase'

    export default {
        name      : "RegisterSuccess",
        components: {
            logo
        },
        watch     : {
            userAccount (val) {
                if ( val === 'admin' || val === 'driver' || val === 'industry' ) {
                    // console.log('admin or driver...');
                    this.$router.push({name: 'toc'})
                } else {
                    // console.log('not admin or driver');
                    this.$router.push({name: 'login'})
                }
            }
        },
        created () {
            this.$store.dispatch('getUserAccount')
        }
    }
</script>

<style scoped>

    .title {
        margin-left: -106px;
    }

    .sub-title {
        margin-top: -20px;
        margin-left: 260px;
    }

    .lime-bar-diag {
        margin-top: -34px;
    }

    .bg-pj-jc {
        background-image: url(../assets/img/reg-complete.png);
    }

    .text {
        max-width: 800px;
    }

</style>
